import { useEffect } from 'react';

const SUFFIX = ' · Menu to Menu';

// Minimal per-route document.title hook. Call from a route component with a
// specific, human-readable title; we add the site-name suffix for you. Pass
// `null` to keep whatever title is already set (useful while data is
// loading). On unmount the previous title is restored so back-navigations
// don't leave a stale tab label.
//
// This is a client-side title swap — LinkedIn/Twitter unfurls read the
// static index.html <title>, not this. The hook's job is the browser tab,
// bookmarks, and the address bar on shared /menu/:id links.
export function useDocumentTitle(title: string | null): void {
  useEffect(() => {
    if (title === null) return;
    const prev = document.title;
    document.title = `${title}${SUFFIX}`;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
